export default {
    'expired lower than effective': 'vendorContract.contract.invalidExpiredDate',
  }
  